var map = {
	"./": 469,
	"./development": 1414,
	"./development.js": 1414,
	"./index": 469,
	"./index.js": 469,
	"./preprod": 1415,
	"./preprod.js": 1415,
	"./production": 1394,
	"./production.js": 1394,
	"./staging": 1416,
	"./staging.js": 1416
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3442;